import * as React from "react";
import { Divider, Paper, Typography } from "@mui/material";
import { motion } from "framer-motion";
import TabsComponent from "../Tabs/Tabs";
import ExportTab from "./ExportTab";
import ScheduleTab from "./ScheduleTab";
import HistoryTab from "./HistoryTab";

const MotionPaper = motion(Paper);

export default function BoxComponent() {
  const [value, setValue] = React.useState("export");

  return (
    <MotionPaper
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      sx={{
        width: "700px",
        p: 2,
      }}
      elevation={0}
      variant="elevation"
    >
      <Typography variant="h3">
        Board<span style={{ color: "#008c23", fontWeight: 900 }}>2</span>Export
      </Typography>

      <Divider sx={{ background: "black", mb: 1 }} />

      <Typography variant="subtitle1" fontWeight={300}>
        With this Power-Up, you can easily export your Trello lists and even
        schedule regular exports to be sent directly to your email. Stay
        organized and keep track of your tasks effortlessly.
      </Typography>

      <Typography variant="subtitle2" fontWeight={100}>
      <strong>Note:</strong> The generated file name will be 
      based on your board's name. If it exceeds 31 characters, 
       will be truncated, and special characters 
       will be removed to ensure compatibility.
      </Typography>

      <TabsComponent value={value} setValue={setValue} />
      {value === "export" && <ExportTab />}
      {value === "schedule" && <ScheduleTab />}
      {value === "history" && <HistoryTab />}
    </MotionPaper>
  );
}
